import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import ChevronIcon from '../icons/chevronIcon';

const CityDropdown = ({ city }) => {
  const history = useHistory();

  return (
    <div className='text-white font-medium' onClick={() => history.push('/city-selector')}>
      {city?.name} <ChevronIcon size='15' color='#fff' rotation={90} />
    </div>
  );
};

export default CityDropdown;
